import { useCallback } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import type { CampaignSearch } from './search';

export function useCampaignPillParam(fallback: string): [string, (pill: string) => void] {
  const navigate = useNavigate();
  const { pill } = useSearch({ strict: false }) as Partial<CampaignSearch>;
  const current = pill ?? fallback;
  const setPill = useCallback(
    (next: string) =>
      navigate({
        to: '.',
        search: ((p: Partial<CampaignSearch>) => ({ ...p, pill: next, page: undefined })),
        // Pill switching is an in-place filter of the SAME table — keep the
        // reader where they are. Without this the router's scrollRestoration
        // treats each ?pill= change as a new location with no saved position
        // and yanks the window to the top (same rationale as
        // useCampaignPageParam / useCampaignPageSizeParam).
        resetScroll: false,
      } as never),
    [navigate],
  );
  return [current, setPill];
}
